export default __webpack_public_path__ + "_/react/assets/images/premium-features/mobile-tc.png";